/* ============================================================================
   MALSERA — ms-home.js
   Carruseles de la landing: categorías, tarjetas de producto y el
   mini-carrusel de dentro de cada tarjeta.

   Los dos carruseles exteriores son desplazamiento NATIVO: durante el gesto
   aquí no corre nada. Este archivo solo mueve con las flechas y sincroniza
   estados.
   ============================================================================ */

/** Flechas para un contenedor con overflow nativo. */
function conectarFlechas(raiz, selectorPista, selPrev, selNext) {
  const pista = raiz.querySelector(selectorPista);
  const prev = raiz.querySelector(selPrev);
  const next = raiz.querySelector(selNext);
  if (!pista || !prev || !next) return;

  const salto = () => Math.round(pista.clientWidth * 0.8);
  prev.addEventListener('click', () => pista.scrollBy({ left: -salto(), behavior: 'smooth' }));
  next.addEventListener('click', () => pista.scrollBy({ left: salto(), behavior: 'smooth' }));

  const revisar = () => {
    const maximo = pista.scrollWidth - pista.clientWidth - 1;
    prev.disabled = pista.scrollLeft <= 0;
    next.disabled = pista.scrollLeft >= maximo;
  };

  let pendiente = false;
  pista.addEventListener(
    'scroll',
    () => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(() => {
        revisar();
        pendiente = false;
      });
    },
    { passive: true }
  );

  if ('ResizeObserver' in window) new ResizeObserver(revisar).observe(pista);
  revisar();
}

/* --- Mini-carrusel de la tarjeta de producto -------------------------------
   Solo existe donde hay cursor. En táctil está DESACTIVADO a propósito: la
   tarjeta vive dentro de un carrusel horizontal y el gesto sería ambiguo.
   Las imágenes 2..4 no se descargan hasta el primer hover: serían 48
   descargas inútiles al entrar en la página.
   -------------------------------------------------------------------------- */
function conectarTarjetas(raiz) {
  if (!window.matchMedia('(hover: hover)').matches) return;

  raiz.querySelectorAll('[data-ms-card]').forEach((tarjeta) => {
    const pista = tarjeta.querySelector('[data-ms-card-pista]');
    const fotos = [...tarjeta.querySelectorAll('.ms-card__foto')];
    const puntos = [...tarjeta.querySelectorAll('.ms-card__punto')];
    if (!pista || fotos.length < 2) return;

    let indice = 0;

    const despertar = () => {
      pista.querySelectorAll('img[data-src]').forEach((img) => {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    };

    const ir = (n) => {
      indice = Math.max(0, Math.min(fotos.length - 1, n));
      pista.style.translate = `${-indice * 100}% 0`;
      puntos.forEach((p, i) => p.classList.toggle('is-active', i === indice));
    };

    tarjeta.addEventListener('pointerenter', despertar, { once: true });

    // Al retirar el cursor vuelve a la primera imagen, como en la referencia.
    tarjeta.addEventListener('pointerleave', () => ir(0));

    tarjeta.querySelector('[data-ms-card-prev]')?.addEventListener('click', (e) => {
      e.preventDefault();
      despertar();
      ir(indice - 1);
    });
    tarjeta.querySelector('[data-ms-card-next]')?.addEventListener('click', (e) => {
      e.preventDefault();
      despertar();
      ir(indice + 1);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ms-categorias]').forEach((s) =>
    conectarFlechas(s, '[data-ms-cats-track]', '[data-ms-cats-prev]', '[data-ms-cats-next]')
  );

  document.querySelectorAll('[data-ms-cards]').forEach((s) => {
    conectarFlechas(s, '[data-ms-cards-track]', '[data-ms-cards-prev]', '[data-ms-cards-next]');
    conectarTarjetas(s);
  });

  document.querySelectorAll('.ms-tira--atmosfera').forEach((tira) => {
    // La tira de atmósfera es un solo enlace: al arrastrar no debe navegar.
    let x0 = 0;
    tira.addEventListener('pointerdown', (e) => (x0 = e.clientX));
    tira.addEventListener('click', (e) => {
      if (Math.abs(e.clientX - x0) > 6) e.preventDefault();
    });
  });
});
